export const locales = ['en', 'da', 'es'] as const;
export type ValidLocale = typeof locales[number];
export const defaultLocale: ValidLocale = 'en';

export const localeNames: Record<ValidLocale, string> = {
  en: 'English',
  da: 'Dansk',
  es: 'Español',
} as const;
